import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'semantic-ui-react'
import DateUtilities from '../componentes/DateUtilities'
import AsignarTrabajo from './AsignarTrabajo/AsignarTrabajo'

class Pendientes extends Component {

	constructor(props) {
		super(props);
		this.state = {
			personas: '',
		};
		this.actividades = props.actividades
		this.key = props.trabajoID;
		this.actividad = props.actividad;
		this.descripcion = props.descripcion;
		this.fechaInicio = props.fechaInicio;
		this.lugarPendiente = props.lugarPendiente;
		this.lugarCompletado = props.lugarCompletado
		this.fechaFin = props.fechaFin;
		this.personas = props.personas;
		this.precio = props.precio;
		this.dificultad = props.dificultad;
		this.handleTerminarPendiente = this.handleTerminarPendiente.bind(this);
		this.boton = this.boton.bind(this);
		this.handleUserInput = this.handleUserInput.bind(this);
	}
	handleUserInput(e, { value, name }) {
		this.setState({
			[name]: value,
		})
	}
	handleTerminarPendiente(id, personas, dificultad, fecha) {
		this.props.terminarPendiente(id, personas, dificultad, fecha);
	}
	setUnidades = (unidad) => {
		switch (this.actividades[this.actividad]) {
			case 'metro':
				return 'metros'
			case 'unidad':
				return 'unidades'
			case 'caja':
				return 'cajas'
			case 'bote':
				return 'botes'
			default:
				return 'metros'
		}
	}
	boton = () => {
		if (this.lugarPendiente === this.lugarCompletado) {
			return (
				<button onClick={this.props.ocultarPendiente(this.key)}>Ocultar</button>
			)
		} else {
			return (
				<Modal trigger={<button>Asignar</button>}>
					<Modal.Header>Asingar Trabajo</Modal.Header>
					<Modal.Content>
						<AsignarTrabajo 
							id={this.key} 
							actividad={this.actividad} 
							descripcion={this.descripcion} 
							unidad={this.setUnidades(this.actividades[this.actividad])} 
						/>
					</Modal.Content>
				</Modal>
			)
		}
	}
	render() {
		return (
			<>
				<td> {this.actividad} </td>
				<td> {this.descripcion} </td>
				{/*<td> {this.fechaFin.toDate().toLocaleDateString()} </td>*/}
				<td> {DateUtilities.GetDayDifference(this.fechaFin.toDate(), DateUtilities.today())} </td>
				<td> {this.lugarPendiente} </td>
				<td> {this.lugarCompletado} </td>
				<td> <this.boton /> </td>
			</>
		);
	}
}

Pendientes.propTypes = {
	actNombre: PropTypes.string
}

export default Pendientes;